// fullscreen img https://static.qualify.talentplatform.eu/clients/215_da529f7a00a67363fd60e7767ddaa094/321_image-transparente.png
//fulscreen logo : https://static.qualify.talentplatform.eu/clients/215_da529f7a00a67363fd60e7767ddaa094/3171_logo-full-color3.png

import defaultMock from '../../language_assessment/examMockConfig';

const examMockConfig = { ...defaultMock, title: 'ASSESS-609_TESTER' };

export default examMockConfig;
//test
